import Cookies from "js-cookie";
import { getToken } from "../auth/getToken";
const BASE_URL = "https://api.iyde.az/api";

export const getLocale = async () => {
  if (typeof window !== "undefined") {
    return Cookies.get("NEXT_LOCALE") || "az";
  } else {
    const { headers } = await import("next/headers");
    const requestHeaders = await headers();
    const cookieHeader = requestHeaders.get("cookie") || "";
    const match = cookieHeader.match(/NEXT_LOCALE=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : "az";
  }
};

const http = async (url, options = {}) => {
  const locale = await getLocale();

  const token = await getToken();

  const headers = {
    "Content-Type": "application/json",
    Language: locale,
    ...(options?.headers || {}),
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  // console.log("url:", url);
  const res = await fetch(`${BASE_URL}/${url}`, {
    next: {
      revalidate: 120,
    },
    method: "GET",
    ...options,
    headers,
  });

  const contentType = res.headers.get("content-type") || "";
  let data;

  if (contentType.includes("application/json")) {
    data = await res.json();
  } else {
    const text = await res.text();
    data = {
      success: false,
      message: text || `Unexpected response format (${res.status})`,
      raw: text,
    };
  }

  if (!res.ok || data?.success === false) {
    const message = data?.title ? data?.message : `Error ${res.status}`;
    const error = new Error(message);
    error.response = data;
    throw error;
  }

  return data;
};

export default http;
